<!-- Box shadow is removed if leg is complete, cancelled, removed, or a deadhead. -->
<div *ngIf="crew$ | async as crew" (click)="onLegClick()" [class.leg-container]="!isFlightDetailView"
  [class.clickable]="!isFlightDetailView && leg?.flightNumber !== '0000'" [class.no-padding]="isFlightDetailView"
  [class.minimal]="minimalView" matRipple [matRippleCentered]="true"
  [matRippleDisabled]="isFlightDetailView || leg?.flightNumber === '0000'">
  <div *ngIf="leg">
    <!-- Alerts/banners -->

    <!-- Next flight -->
    <div *ngIf="leg.isNextLeg && !minimalView" class="alert success-alert">
      <mat-icon class="icon-sm opacity-6">flight</mat-icon>
      Next
    </div>

    <!-- Deadhead -->
    <div *ngIf="leg.isDeadhead && leg.flightNumber !== '0000' && !minimalView" class="alert caution-alert">
      <mat-icon class="icon-sm opacity-6">airplane_ticket</mat-icon>
      Deadhead
    </div>

    <!-- Surface/misc -->
    <div *ngIf="leg.flightNumber === '0000'" class="alert caution-alert">
      Surface/Misc Duty
    </div>

    <!-- Cancelled -->
    <div *ngIf="leg.isCancelled" class="alert warn-alert">
      <mat-icon class="icon-sm opacity-6">cancel</mat-icon>
      <span>Canceled</span>
      <!-- <div>
        <button mat-button color="primary" (click)="onCxlDetailsClick()">Details</button>
      </div> -->
    </div>

    <!-- Removed -->
    <div *ngIf="leg.removeCode !== '' && !minimalView" class="alert warn-alert">
      <mat-icon class="icon-sm opacity-6">person_remove</mat-icon>
      {{ REMOVE_CODES[leg.removeCode] || "Removed" }}
    </div>

    <!-- Air return -->
    <div *ngIf="leg.airInterrupt" class="alert caution-alert">
      <mat-icon class="icon-sm opacity-6">undo</mat-icon>
      Air Return
    </div>

    <!-- Ground return -->
    <div *ngIf="leg.groundInterrupt" class="alert caution-alert">
      <mat-icon class="icon-sm opacity-6">undo</mat-icon>
      Ground Return
    </div>

    <!-- Diversion -->
    <div *ngIf="leg.isDiversion" class="alert caution-alert">
      <mat-icon class="icon-sm opacity-6">flight_land</mat-icon>
      Diversion
    </div>

    <!-- Diversion continuation -->
    <div *ngIf="leg.isDiversionContinuation" class="alert caution-alert">
      <mat-icon class="icon-sm opacity-6">moving</mat-icon>
      Diversion Continuation
    </div>

    <!-- Summary table -->
    <table class="leg-table">
      <!-- Flight number, dep/arr station row -->
      <tr>
        <td class="flt-number value-1">
          {{ leg.flightNumber | rmvLeadingZeroes }}
        </td>
        <td class="station-gate">
          <span *ngIf="!minimalView" matRipple class="text-button station-button"
            (click)="onStationClick(leg.depStation)">
            {{ leg.depStation }}
          </span>
          <span *ngIf="minimalView" class="station-button accent-color">
            {{ leg.depStation }}
          </span>
          <span *ngIf="crew.response as crewList" class="gate">{{
            crewList.gate.depart || "&nbsp;"
            }}</span>
          <app-skeleton *ngIf="crew.isLoading && !crew.response" [inline]="true" width="1.25rem"
            height=".5rem"></app-skeleton>
        </td>

        <td class="station-gate">
          <span *ngIf="!minimalView" matRipple class="text-button station-button"
            (click)="onStationClick(leg.arrStation)">
            {{ leg.arrStation }}
          </span>
          <span *ngIf="minimalView" class="station-button accent-color">
            {{ leg.arrStation }}
          </span>
          <span *ngIf="crew.response as crewList" class="gate">{{
            crewList.gate.arrive
            }}</span>
          <app-skeleton *ngIf="crew.isLoading && !crew.response" [inline]="true" width="1.25rem"
            height=".5rem"></app-skeleton>
        </td>
        <td *ngIf="!minimalView" class="label-3 pt-25">Fly</td>
        <td *ngIf="!minimalView"></td>
      </tr>

      <!-- Scheduled row -->
      <tr>
        <td class="skd-label label-3 pt-25">Sched</td>
        <td class="value-2" [class.opacity-4]="leg.depTimeActual || leg.depTimeResched">
          {{ leg.depTimeSched?.toLocaleString(DateTime.TIME_24_SIMPLE) }}
        </td>
        <td class="value-2" [class.opacity-4]="leg.depTimeActual || leg.depTimeResched">
          {{ leg.arrTimeSched?.toLocaleString(DateTime.TIME_24_SIMPLE) }}
        </td>
        <td *ngIf="!minimalView" class="value-2" [class.opacity-4]="leg.depTimeActual || leg.depTimeResched">
          {{ leg.flightTimeSched.toFormat("h:mm") }}
        </td>
        <td *ngIf="!minimalView"></td>
      </tr>

      <!-- Rescheduled row -->
      <tr *ngIf="leg.depTimeResched && leg.arrTimeResched">
        <td class="skd-label label-3 pt-25 warn-color">Resched</td>
        <td class="value-2 warn-color" [class.value-4]="leg.depTimeActual">
          {{ leg.depTimeResched.toLocaleString(DateTime.TIME_24_SIMPLE) }}
        </td>
        <td class="value-2 warn-color" [class.value-4]="leg.depTimeActual">
          {{ leg.arrTimeResched.toLocaleString(DateTime.TIME_24_SIMPLE) }}
        </td>
        <td *ngIf="!minimalView" class="value-2 warn-color" [class.value-4]="leg.depTimeActual">
          {{ leg.flightTimeSched.toFormat("h:mm") }}
        </td>
        <td *ngIf="!minimalView"></td>
      </tr>

      <!-- Delayed row -->
      <tr *ngIf="leg.depTimeActual && leg.isDepEstimated">
        <td class="skd-label label-3 pt-25">Delayed</td>
        <td class="value-2 warn-color">
          {{ leg.depTimeActual.toLocaleString(DateTime.TIME_24_SIMPLE) }}
        </td>
        <td class="value-2 warn-color">
          {{ leg.arrTimeActual?.toLocaleString(DateTime.TIME_24_SIMPLE) }}
        </td>
        <td *ngIf="!minimalView" class="value-2 warn-color">
          {{ leg.flightTimeActual.toFormat("h:mm") }}
        </td>
        <td *ngIf="!minimalView"></td>
      </tr>

      <!-- Actual row -->
      <tr *ngIf="leg.depTimeActual && !leg.isDepEstimated">
        <td class="skd-label label-3 pt-25 accent-color">Actual</td>
        <td class="value-2">
          {{ leg.depTimeActual.toLocaleString(DateTime.TIME_24_SIMPLE) }}
        </td>
        <td class="value-2">
          {{ leg.arrTimeActual?.toLocaleString(DateTime.TIME_24_SIMPLE) }}
        </td>
        <td *ngIf="!minimalView" class="value-2">{{ leg.flightTimeActual.toFormat("h:mm") }}</td>
        <!-- <td class="success-color act-vs-sched">
          <div *ngIf="
              leg.actFlightTimeVsSched.as('minutes') > 0 && !leg.isDeadhead
            ">
            +{{ leg.actFlightTimeVsSched.as("minutes") }}
          </div>
        </td> -->
      </tr>

      <!-- Overfly row -->
      <tr *ngIf="leg.actFlightTimeVsSched.as('minutes') > 0 && !leg.isDeadhead && !minimalView">
        <td></td>
        <td></td>
        <td></td>
        <td class="success-color act-vs-sched">
          +{{ leg.actFlightTimeVsSched.as("minutes") }}
        </td>
      </tr>
    </table>

    <div *ngIf="!minimalView" class="secondary-container">
      <div class="secondary-content thin-gray-border">
        <div class="width-100">
          <div class="value-2 text-center">{{ leg.aircraft.short }}</div>
          <div class="label-3 pt-25 text-center">Aircraft</div>
        </div>
        <!-- Show ground or layover label as appropriate (layover if last leg of duty day) -->
        <div *ngIf="!leg.isDpEnd" class="width-100 left-divider-1">
          <div *ngIf="!leg.isDpEnd" class="value-2 text-center">
            {{ leg.groundTimeActual.toFormat("h:mm") || "" }}
          </div>
          <div *ngIf="!leg.isDpEnd || leg.isSeqEnd" class="label-3 pt-25 text-center">
            Ground
          </div>
        </div>
        <div *ngIf="leg.isDpEnd && leg.odlActual.as('minutes') > 0" class="width-100 left-divider-1">
          <div *ngIf="leg.isDpEnd && !leg.isSeqEnd" class="value-2 text-center">
            {{ leg.odlActual.toFormat("h:mm") || "" }}
          </div>
          <div *ngIf="leg.isDpEnd && !leg.isSeqEnd" class="label-3 pt-25 text-center">
            Layover
          </div>
        </div>
        <div class="width-100 left-divider-1">
          <div *ngIf="leg.meal" class="value-2 text-center success-color font-bold">
            {{ leg.meal }}
          </div>
          <div *ngIf="!leg.meal" class="no-meal">
            <mat-icon class="no-meal-icon warn-color" inline="true">no_meals</mat-icon>
          </div>
          <div class="label-3 pt-25 text-center">Meal</div>
        </div>

        <!-- Delay times -->
        <div *ngIf="leg.rampDelay.as('minutes') > 0" class="width-100 left-divider-1">
          <div class="text-center success-color text-base">
            +{{ leg.rampDelay.as("minutes") }}
          </div>
          <div class="label-3 pt-25 text-center">Ramp</div>
        </div>
        <div *ngIf="leg.atcDelay.as('minutes') > 0" class="width-100 left-divider-1">
          <div class="text-center success-color text-base">
            +{{ leg.atcDelay.as("minutes") }}
          </div>
          <div class="label-3 pt-25 text-center">ATC</div>
        </div>
        <div *ngIf="leg.deiceDelay.as('minutes') > 0" class="width-100 left-divider-1">
          <div class="text-center success-color text-base">
            +{{ leg.deiceDelay.as("minutes") }}
          </div>
          <div class="label-3 pt-25 text-center">Deice</div>
        </div>
        <div *ngIf="leg.diversionTime.as('minutes') > 0" class="width-100 left-divider-1">
          <div class="text-center success-color text-base">
            +{{ leg.diversionTime.as("minutes") }}
          </div>
          <div class="label-3 pt-25 text-center">Divert</div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="timeToDeparture$ | async as timeToDeparture">
    <!-- <div *ngIf="timeToDeparture.shouldDisplay" class="lower-divider">
      <mat-divider></mat-divider>
    </div> -->

    <!-- Time until departure -->
    <div *ngIf="timeToDeparture.shouldDisplay" class="time-to-dep">
      <div class="text-sm departs-label">Departs in
        <span *ngIf="timeToDeparture.hours !== 0" class="font-bold">{{ timeToDeparture.hours }}</span>
        <span *ngIf="timeToDeparture.hours !== 0"> hr </span>
        <span class="font-bold"
          [class.success-color]="timeToDeparture.totalMinutes < 60 && timeToDeparture.totalMinutes > 10"
          [class.caution-color]="timeToDeparture.totalMinutes <= 10 && timeToDeparture.totalMinutes > 0"
          [class.warn-color]="timeToDeparture.totalMinutes <= 0">{{ timeToDeparture.minutes }}</span>
        <span> min</span>
      </div>
      <mat-progress-bar [color]="timeToDeparture.totalMinutes <= 0 ? 'warn' : 'accent'" mode="determinate"
        [value]="(1-(timeToDeparture.totalMinutes/60))*100" class="boarding-progress-bar"></mat-progress-bar>
      <div class="text-xs text-center opacity-4 one-hr-label">1 hr</div>
    </div>
  </ng-container>

  <div *ngIf="!leg && isLoading">
    <mat-spinner color="accent" [diameter]="35"></mat-spinner>
  </div>

  <div *ngIf="!leg && !isLoading">
    <div class="text-center">Flight not found</div>
  </div>

  <div *ngIf="isFlightDetailView" class="data-status">
    <app-data-status [timestamp]="leg?.timestamp" [isLoading]="isLoading"
      (refresh)="refreshSequence()"></app-data-status>
  </div>
</div>
